import { render, staticRenderFns } from "./typeList.vue?vue&type=template&id=bf0855e2&scoped=true&"
import script from "./typeList.vue?vue&type=script&lang=js&"
export * from "./typeList.vue?vue&type=script&lang=js&"
import style0 from "./typeList.vue?vue&type=style&index=0&id=bf0855e2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0855e2",
  null
  
)

export default component.exports